import { Injectable } from '@angular/core';

import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {

  readonly deviceId: string;

  constructor() {
    const deviceId = localStorage.getItem('deviceId');
    if (deviceId) {
      this.deviceId = deviceId;
      console.log(`Using device id: ${this.deviceId}`);
    } else {
      this.deviceId = uuidv4();
      localStorage.setItem('deviceId', this.deviceId);
      console.log(`New device id created: ${this.deviceId}`);
    }
  }
}
